export const HANDLE_ON_CHANGE = 'HANDLE_ON_CHANGE';
export const HANDLE_ON_CHANGE_OBJECT = 'HANDLE_ON_CHANGE_OBJECT';
export const INCIDENT_DETAILS = 'INCIDENT_DETAILS';//incident_details 
export const INCIDENT_CATEGORY_MASTER = 'INCIDENT_CATEGORY_MASTER';//incident_category_master 
export const INCIDENT_SLA_MASTER = 'INCIDENT_SLA_MASTER';//company_sla_master 
export const INCIDENT_SLA_DETAILS = 'INCIDENT_SLA_DETAILS';//agilesaas_incident_sla_details 


